export default __webpack_public_path__ + "static/media/bg.dfa6ae4f.webp";